import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
    className?: string;
}

const BackButton = ({className}: BackButtonProps) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const goBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <button
      onClick={goBack}
      type="button"
      className={`text-gray-900 bg-white border border-gray-300 font-medium rounded-md hover:bg-gray-100 text-sm px-5 py-1 me-2 mb-2 ${className}`}
    >
      {t('generalWords.back')}
    </button>
  );
};

export default BackButton;

